import { useState } from 'react';

import { Notification, request } from 'src/utils';
import TasksService from 'src/services/tasks.service';
import { ITaskChecklistItem } from 'src/interfaces/task';

import { IProps } from './checklist.type';

const useChecklist = (props: IProps) => {
  const [savingId, setSavingId] = useState<number | null>(null);

  const handleToggle = async (item: ITaskChecklistItem, completed: boolean) => {
    if (!props.task) return;

    setSavingId(item.id);

    try {
      await TasksService.updateChecklistItems(String(props.task.id), {
        items: [
          {
            id: item.id,
            completed,
            notes: item.notes || undefined,
          },
        ],
      });

      await props.fetchTask(String(props.task.id));
    } catch (err) {
      request.errors(err);
      Notification.error({
        message: 'Não foi possível atualizar o item do checklist.',
      });
    } finally {
      setSavingId(null);
    }
  };

  const handleNotesBlur = async (item: ITaskChecklistItem, notes: string) => {
    if (!props.task) return;
    if ((item.notes || '') === notes) return;

    setSavingId(item.id);

    try {
      await TasksService.updateChecklistItems(String(props.task.id), {
        items: [
          {
            id: item.id,
            completed: item.completed,
            notes,
          },
        ],
      });

      await props.fetchTask(String(props.task.id));
    } catch (err) {
      request.errors(err);
      Notification.error({
        message: 'Não foi possível salvar as observações do checklist.',
      });
    } finally {
      setSavingId(null);
    }
  };

  return {
    savingId,
    handleToggle,
    handleNotesBlur,
  };
};

export default useChecklist;
